module.exports = __webpack_public_path__ + "fonts/PilatExtended-Light.woff2";